import { useEffect, useRef, useState } from 'react';

/**
 * Tracks whether a (typically line-clamped) element overflows its rendered box.
 * Re-measures on content changes and on element resize so the result stays
 * accurate across responsive layout changes.
 */
export function useIsOverflowing<T extends HTMLElement = HTMLDivElement>(deps: unknown[] = []) {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setIsOverflowing(el.scrollHeight > el.clientHeight + 1);

    check();

    const resizeObserver = new ResizeObserver(check);
    resizeObserver.observe(el);
    return () => resizeObserver.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { ref, isOverflowing };
}
